"use client";
import { jsx } from "react/jsx-runtime";
import { useState, useEffect } from "react";
import { useAuth } from "../../../../hooks/auth/useAuth/index.js";
import { SignInRegisterView } from "./view.signInRegister.js";
function MyAccountLinkSession({
  AccountView,
  dataTestId = "",
  entry,
  locale
}) {
  const [isLoggedIn, setIsLoggedIn] = useState();
  const { isUserSignedIn, isLoading } = useAuth();
  useEffect(() => {
    if (!isLoading) {
      isUserSignedIn().then((result) => {
        setIsLoggedIn(result);
      });
    }
  }, [isUserSignedIn, isLoading]);
  if (!entry || isLoggedIn === void 0) return null;
  return isLoggedIn ? AccountView : /* @__PURE__ */ jsx(
    SignInRegisterView,
    {
      dataTestId,
      entry,
      locale
    }
  );
}
export {
  MyAccountLinkSession
};
